var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.43,48.36c5.93,0,11.06-2.13,15.25-6.32c4.19-4.19,6.32-9.33,6.32-15.25c0-5.93-2.13-11.06-6.32-15.25  c-4.19-4.19-9.33-6.32-15.25-6.32c-5.93,0-11.06,2.13-15.25,6.32s-6.32,9.33-6.32,15.25c0,5.93,2.13,11.06,6.32,15.25  C38.38,46.23,43.51,48.36,49.43,48.36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.18,74.09c-0.12-1.75-0.37-3.65-0.73-5.66c-0.36-2.03-0.83-3.94-1.39-5.69c-0.58-1.81-1.37-3.6-2.34-5.31  c-1.01-1.78-2.2-3.32-3.53-4.6c-1.39-1.33-3.1-2.4-5.07-3.18c-1.96-0.78-4.14-1.17-6.47-1.17c-0.91,0-1.8,0.38-3.51,1.49  c-1.05,0.69-2.28,1.48-3.65,2.35c-1.17,0.75-2.76,1.45-4.73,2.08c-1.92,0.62-3.86,0.93-5.78,0.93c-1.92,0-3.86-0.31-5.78-0.93  c-1.96-0.63-3.55-1.33-4.72-2.08c-1.36-0.87-2.59-1.66-3.66-2.36c-1.71-1.11-2.59-1.49-3.51-1.49c-2.33,0-4.5,0.39-6.47,1.17  c-1.97,0.78-3.67,1.85-5.07,3.18c-1.33,1.27-2.52,2.82-3.53,4.6c-0.97,1.71-1.76,3.5-2.34,5.31c-0.56,1.75-1.03,3.66-1.39,5.69  c-0.36,2.01-0.6,3.91-0.73,5.66c-0.12,1.71-0.18,3.49-0.18,5.29c0,4.68,1.49,8.46,4.42,11.25c2.89,2.75,6.73,4.15,11.38,4.15h43.13  c4.66,0,8.49-1.4,11.38-4.15c2.93-2.79,4.42-6.58,4.42-11.25C87.37,77.58,87.3,75.8,87.18,74.09z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9a8fd709934fdeba5bccfc34064d764b.svg";
export { ForwardRef as ReactComponent };